import { connect } from 'react-redux';
import decorate from '../../utils/decorate';
import { Map, List } from 'immutable';
import Ladders from './Ladders.jsx';

//Sports Ladder
import { request as getLaddersList } from '../../modules/ladders/actions/get-list';
import { request as getSportLadder } from '../../modules/ladders/actions/getSportLadder';
import { request as updateSportLadder } from '../../modules/ladders/actions/updateSportLadder';
import { request as copySportLadder } from '../../modules/ladders/actions/copySportLadder';

//Master Ladder CRUD
import { request as getMaster } from '../../modules/ladders/actions/masterLadder/get';
import { request as createMasterLadderPrice } from '../../modules/ladders/actions/masterLadder/createPrice';
import { request as updateMasterLadderPrice } from '../../modules/ladders/actions/masterLadder/updatePrice';
import { request as deleteMasterLadderPrice } from '../../modules/ladders/actions/masterLadder/deletePrice';

//Sport Names
import { request as getSports } from '../../modules/sports/actions/get';

function mapStateToProps(state) {
    return {
        ladders: state.ladders.get('items', Map()).sortBy((item, key) => key) || Map(),
        masterLadder: state.ladders.getIn(['master-ladder', 'prices']) || Map(),
        state: state.ladders.get('state'),
        sportsNames: state.sports.get('items') || Map()
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //Sport Ladders API
        onGetLaddersList: () => dispatch(getLaddersList()),
        onGetSportLadder: (sportId) => dispatch(getSportLadder(sportId)),
        onSaveSportLadder: (sportId, ladder) => dispatch(updateSportLadder(sportId, ladder)),
        onCopySportLadder: (target, sport) => dispatch(copySportLadder(target, sport)),

        //Master Laddeer CRUD
        onGetMasterLadder: () => dispatch(getMaster()),
        onSavePrice: (price, oldPrice) => dispatch(updateMasterLadderPrice(price, oldPrice)),
        onCreatePrice: (price) => dispatch(createMasterLadderPrice(price)),
        onDeletePrice: (price) => dispatch(deleteMasterLadderPrice(price)),

        //get sports names
        onGetSports: () => dispatch(getSports())
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    Ladders
);
